var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 7.42206L13.5 11.4221M13.5 11.4221L9.5 15.4221M13.5 11.4221H0.5M0.837822 6.42206C2.56687 3.43305 5.79859 1.42206 9.5 1.42206C15.0228 1.42206 19.5 5.89921 19.5 11.4221C19.5 16.9449 15.0228 21.4221 9.5 21.4221C5.79859 21.4221 2.56687 19.4111 0.837822 16.4221",
    stroke: "#330812",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout_icon.135ce7a1ea166460f4d27a45cc938cd5.svg";
export { ForwardRef as ReactComponent };